export const vehicleTypeAll = "ALL";

export enum CargoStatusCode {
  both = "Both",
  unaccompanied = "Unaccompanied",
  accompanied = "Accompanied",
}
